import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const ICheckTask = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill={props.color ?? '#37474F'}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.4207 8.32198C14.7366 8.05404 14.7754 7.58076 14.5075 7.26487C14.2396 6.94899 13.7663 6.91012 13.4504 7.17806L7.9561 11.8384L6.28033 10.1626C5.98744 9.86969 5.51256 9.86969 5.21967 10.1626C4.92678 10.4555 4.92678 10.9304 5.21967 11.2232L7.15901 13.1626C7.26706 13.2706 7.39988 13.3388 7.53919 13.3672C7.81372 13.5857 8.21313 13.5873 8.49086 13.3517L14.4207 8.32198Z"
              fill={props.color ?? '#37474F'}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
              fill={props.color ?? '#37474F'}
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default ICheckTask;
